module.exports = __webpack_public_path__ + "img/spot.3937ed7c.png";